"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chapterFloatingButtons = exports.chapterButtons = void 0;
var fab = __importStar(require("../../../shared/fab"));
var resolveTypographyVariantStyles_1 = require("../../../utils/resolveTypographyVariantStyles");
var primary_1 = require("./primary");
var secondary_1 = require("./secondary");
var sizes_1 = require("./sizes");
var tertiary_1 = require("./tertiary");
exports.chapterButtons = {
    variants: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], primary_1.primaryButtons, true), secondary_1.secondaryButtons, true), tertiary_1.tertiaryButtons, true), sizes_1.sizeOverrides, true),
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return (__assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'buttonLabel')));
        },
    },
};
exports.chapterFloatingButtons = [
    fab.navigation,
    fab.navigationHC,
    fab.alternative,
    fab.defaultVariant,
    fab.highContrast,
    fab.fabSizeS,
    fab.fabSizeM,
    fab.fabSizeL,
];
